import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const JobsPage = lazy(() => import('../pages/jobs/page'));
const JobDetailPage = lazy(() => import('../pages/job-detail/page'));
const EmployersPage = lazy(() => import('../pages/employers/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterCandidatePage = lazy(() => import('../pages/auth/register-candidate/page'));
const RegisterEmployerPage = lazy(() => import('../pages/auth/register-employer/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password/page'));
const GoogleSuccessPage = lazy(() => import('../pages/auth/google-success/page'));
const CandidateRegisterPage = lazy(() => import('../pages/candidate-register/page'));
const CandidateDashboardPage = lazy(() => import('../pages/candidate-dashboard/page'));
const EmployerDashboardPage = lazy(() => import('../pages/employer-dashboard/page'));
const InternationalRecruitmentPage = lazy(() => import('../pages/international-recruitment/page'));
const BranchesPage = lazy(() => import('../pages/branches/page'));
const SecteursMetiersPage = lazy(() => import('../pages/secteurs-metiers/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/connexion/page'));
const JobApplyPage = lazy(() => import('../pages/job-apply/page'));
const AeronautiquePage = lazy(() => import('../pages/aeronautique/page'));
const AdminCollabPage = lazy(() => import('../pages/admin-collab/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticlePage = lazy(() => import('../pages/blog/article/page'));
const TrackingPage = lazy(() => import('../pages/international-recruitment/suivi/page'));
const ConfirmerEntretienPage = lazy(() => import('../pages/international-recruitment/ConfirmerEntretien'));
const NotificationsPage = lazy(() => import('../pages/Notifications'));
const CandidatureTrackingPage = lazy(() => import('../pages/suivi-candidature/page'));
const ConditionsPage = lazy(() => import('../pages/conditions/page'));
const ConfidentialitePage = lazy(() => import('../pages/confidentialite/page'));
const CMSPage = lazy(() => import('../pages/PageCMSContent'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/offres',
    element: <JobsPage />
  },
  {
    path: '/offres-emploi',
    element: <JobsPage />
  },
  {
    path: '/offre/:id',
    element: <JobDetailPage />
  },
  {
    path: '/offres/:id',
    element: <JobDetailPage />
  },
  {
    path: '/offres-emploi/:id',
    element: <JobDetailPage />
  },
  {
    path: '/offres-emploi/:id/postuler',
    element: <JobApplyPage />
  },
  {
    path: '/employeurs',
    element: <EmployersPage />
  },
  {
    path: '/connexion',
    element: <LoginPage />
  },
  {
    path: '/inscription-candidat',
    element: <RegisterCandidatePage />
  },
  {
    path: '/mot-de-passe-oublie',
    element: <ForgotPasswordPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/auth/google-success',
    element: <GoogleSuccessPage />
  },
  {
    path: '/candidats/inscription',
    element: <CandidateRegisterPage />
  },
  {
    path: '/inscription-employeur',
    element: <RegisterEmployerPage />
  },
  {
    path: '/employeurs/inscription',
    element: <RegisterEmployerPage />
  },
  {
    path: '/tableau-de-bord-candidat',
    element: (
      <ProtectedRoute allowedRoles={['candidate']}>
        <CandidateDashboardPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/tableau-de-bord-employeur',
    element: (
      <ProtectedRoute allowedRoles={['employer']}>
        <EmployerDashboardPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/recrutement-international',
    element: <InternationalRecruitmentPage />
  },
  {
    path: '/recrutement-international/suivi/:numero',
    element: <TrackingPage />
  },
  {
    path: '/entretien/confirmation/:token',
    element: <ConfirmerEntretienPage />
  },
  {
    path: '/succursales',
    element: <BranchesPage />
  },
  {
    path: '/secteurs-metiers',
    element: <SecteursMetiersPage />
  },
  {
    path: '/a-propos',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/faq',
    element: <FaqPage />
  },
  {
    path: '/crm/connexion',
    element: <AdminLoginPage />
  },
  {
    path: '/crm',
    element: (
      <ProtectedRoute allowedRoles={['admin']} redirectTo="/crm/connexion">
        <AdminPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/crm/collaborateur',
    element: (
      <ProtectedRoute allowedRoles={['collaborator', 'admin']} redirectTo="/crm/connexion">
        <AdminCollabPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/aeronautique',
    element: <AeronautiquePage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:id',
    element: <ArticlePage />
  },
  {
    path: '/notifications',
    element: (
      <ProtectedRoute allowedRoles={['candidate', 'employer', 'admin', 'collaborator']}>
        <NotificationsPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/suivi-candidature',
    element: <CandidatureTrackingPage />
  },
  {
    path: '/conditions',
    element: <ConditionsPage />
  },
  {
    path: '/confidentialite',
    element: <ConfidentialitePage />
  },
  {
    path: '/page/:id',
    element: <CMSPage />
  },
  {
    path: '/admin/*',
    element: <Navigate to="/crm" replace />
  },
  {
    path: '/admin/connexion',
    element: <Navigate to="/crm/connexion" replace />
  },
  {
    path: '/admin/collaborateur',
    element: <Navigate to="/crm/collaborateur" replace />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;